const headers = {'Content-Type': 'application/json;charset=UTF-8'}
const platform_type = 'shopify'

const url_header ='https://shopify-ctm.doris.itocases.com/v3/overseas/ito/'

function login(email,password) {
  return new Promise(function(resolve, reject) {
    var data = {
      email:email,
      password:password
    }
    var r = new XMLHttpRequest();
    r.open("POST",url_header+'login', true);
    r.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    r.onreadystatechange = function(){
      if (r.readyState === 4) {
        try {
          if (r.status === 200){
            var response = JSON.parse(decodeURIComponent(r.responseText || '{}'))
            if(response.code == 0){
              sessionStorage.setItem('ITOUser',JSON.stringify(response.data))
              sessionStorage.setItem('ITOAccessToken',response.data.accessToken)
              resolve(response.data)
            }else{
              reject(response)
            }
          }else{
            reject('Network Error'+r.status)
          }
        } catch (err) {
          reject(err);
        }
      }
    }
    
    r.send(JSON.stringify(data));
  })
}

function register(first_name,last_name,email,password,platform_id,code,scene) {
  return new Promise(function(resolve, reject) {
    var data = {
      first_name:first_name,
      last_name:last_name,
      email:email,
      password:password,
      code:code,
      platform_id:platform_id,
      platform_type:platform_type,
      scene:scene
    }
    var r = new XMLHttpRequest();
    r.open("POST",url_header+'register', true);
    r.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    r.onreadystatechange = function(){
      if (r.readyState === 4) {
        try {
          var response = JSON.parse(decodeURIComponent(r.responseText || '{}'))
          console.log(response)
          if(response.code == 0){
            sessionStorage.setItem('ITOUser',JSON.stringify(response.data))
            sessionStorage.setItem('ITOAccessToken',response.data.accessToken)
            resolve(response.data)
          }else{
            reject(response)
          }
        } catch (err) {
          reject(err);
        }
      }
    }
    r.send(JSON.stringify(data));
  })
}

// 通用请求方法
function sendRequest(api,method,params,header = {},skipAuth = false){
  return new Promise(async function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    var url = `${url_header}${api}`
    method = method.toUpperCase();
    if(!skipAuth && !sessionStorage.getItem('ITOAccessToken')){
      var email = sessionStorage.getItem('ITOCustomerEmail')
      var platform_id = sessionStorage.getItem('ITOCustomerId')
      try {
        await register('','',email,'',platform_id,'','request')
      } catch (err) {
        reject(err)
        return
      }
    }
    var token = sessionStorage.getItem('ITOAccessToken')
    header = {...headers,...header,...{"Authorization":token}}
    
    // if(method == 'GET')
    //   delete header['Content-Type']
    
    // 格式化参数为 query string（例如 name=John&age=30）
    const paramString = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
    
    if (method === 'GET') {
      const fullUrl = paramString ? `${url}?${paramString}` : url;
      xhr.open('GET', fullUrl, true);
    } else if (method === 'POST') {
      xhr.open('POST', url, true);
    } 
    // 处理请求头
    var header_list = Object.entries(header)
    for (var i=0;i<header_list.length;i++){
      xhr.setRequestHeader(header_list[i][0], header_list[i][1]);
    }
    xhr.onreadystatechange = async function(){
      if (xhr.readyState === 4) {
        try {
          if (xhr.status == 200) {
            var response = JSON.parse(decodeURIComponent(xhr.responseText || '{}'))
            if(response.code == 0){
              resolve(response.data)
            }else{
              reject(response)
            }
          } else if(xhr.status == 401) {
            var email = sessionStorage.getItem('ITOCustomerEmail')
            await login(email,'')
            sendRequest(api,method,params,header).then(res=>{resolve(res)}).catch(err=>{reject(err)})
          } else 
            reject(decodeURIComponent(xhr.responseText))
        } catch (err) {
          reject(err);
        }
      }
    }
    if (method === 'GET') {
      xhr.send();
    } else if (method === 'POST') {
      xhr.send(JSON.stringify(params));
    }
  })
}


window.loginRequest = login;
window.registerRequest = register;
window.sendRequest = sendRequest;
